import React from 'react'
import NavbarContainer from '../components/NavbarContainer/NavbarContainer'
import ChooseStageContainer from '../components/ChooseStageContainer/ChooseStageContainer'
import { Container } from 'react-bootstrap'

function ChooseStage() {
  return (
    <div>
      <NavbarContainer />
      <Container className='pt-5'>
        <ChooseStageContainer />

      </Container>
    </div>
  )
}

export default ChooseStage